import styles from './ChatAnswer.module.scss';
import ChatMarkdown from './ChatMarkdown';
import { useAutoScroll } from './hooks';

interface ChatAnswerProps {
  currentAnswer: string;
  questionId: string;
}

const ChatAnswer: React.FC<ChatAnswerProps> = ({
  currentAnswer,
  questionId,
}) => {
  // Use the auto-scroll hook instead of managing all the state directly
  const {
    ref: chatAnswerRef,
    height: chatAnswerHeight,
    handleScroll,
  } = useAutoScroll(currentAnswer, {
    maxHeight: 8 * 44,
    bottomBuffer: 30,
  });

  return (
    <div className={styles.chatAnswerContainer}>
      <div
        className={styles.chatAnswer}
        id='chatAnswer'
        ref={chatAnswerRef}
        style={{ height: chatAnswerHeight }}
        onScroll={handleScroll}
      >
        <ChatMarkdown body={currentAnswer} />
      </div>
    </div>
  );
};

ChatAnswer.displayName = 'ChatAnswer';
export default ChatAnswer;
